//
// Global constants across clients and servers
// Note: this file in imported by both client and server side code
//       therefore, do not include server or client specific imports

// Super User across all projects
export const SUPER_USER = 1;

// Roles for organization
export const ORGROLE_ADMIN = 2;
export const ORGROLE_MEMBER = 3;

// Roles for accounts
export const ACCTROLE_ADMIN = 2;
export const ACCTROLE_MEMBER = 3;

// Roles for projects
export const PROJROLE_ADMIN = 2;
export const PROJROLE_MEMBER = 3;
export const PROJROLE_READER = 4;

export const ROLE_NAME = ['', 'Super User', 'Admin', 'Member', 'Reader'];



// WEBPACK FOOTER //
// ./src/shared/constants.js